export interface ParsedProductFreights {
  validFreightItems: Set<string>
  validFreightClasses: Set<string>
  freightPairs: Map<string, { item: string; class: string; description: string }>
}

export enum AddProductDialogStep {
  PRODUCT_INFO = "PRODUCT_INFO",
  PRODUCT_SPECIFICS = "PRODUCT_SPECIFICS",
}
